import { useLocalObservable } from 'mobx-react-lite';

import { IDevices } from '@gem/call/tasks/getDefaultDevices';

export interface ICallPreviewDevicesPresenter {
  isAudioMuted: boolean;
  isVideoMuted: boolean;
  devicesIds: IDevices;

  onChangeInitialDevicesIds(devicesIds: IDevices): void;
  onChangeAudioMuted(value: boolean): void;
  onChangeVideoMuted(value: boolean): void;
}

export const useCallPreviewDevicesPresenter = (): ICallPreviewDevicesPresenter => {
  const presenter = useLocalObservable<ICallPreviewDevicesPresenter>(() => ({
    isAudioMuted: true,
    isVideoMuted: true,
    devicesIds: {
      audioinput: null,
      audiooutput: null,
      videoinput: null,
    },

    onChangeVideoMuted(value: boolean): void {
      presenter.isVideoMuted = value;
    },

    onChangeAudioMuted(value: boolean): void {
      presenter.isAudioMuted = value;
    },

    onChangeInitialDevicesIds(devicesIds: IDevices): void {
      presenter.devicesIds = devicesIds;
    },
  }));

  return presenter;
};
